







import { Prop, Component, Vue } from "vue-property-decorator";

@Component({})
export default class ScheduleEventList extends Vue {
  @Prop({ type: Boolean }) empty!: boolean;
}
